import { useEffect } from 'react'
import { LoadDataFromParams } from '../../Utils/url-helpers'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import { fetcher } from '../../Utils/fetcher'
import { getBaseApi, getLocaleFromUrlOrQuery } from '../../Utils/common'
import { RoutesResponse } from './route-types'

export const useLoadRoutesIntoContext = (minibookId?: string) => {
  const { dispatch } = useTravelSearchContext()
  const { queryData } = LoadDataFromParams()

  useEffect(() => {
    if (!minibookId) return

    const fetchRoutes = async () => {
      dispatch({ type: 'SET_ROUTES_API_LOADING', payload: true })

      const baseApi = getBaseApi()
      const locale = getLocaleFromUrlOrQuery()
      const url = `${baseApi}/routes?locale=${locale}&minibookId=${minibookId}`

      try {
        const routesApiData: RoutesResponse = await fetcher(url)

        let route = routesApiData.defaultRoute ?? routesApiData.categories?.[0]?.routes?.[0]

        if (queryData.routeCode) {
          const found = routesApiData.categories.flatMap((c) => c.routes).find((r) => r.routeCode === queryData.routeCode)

          if (found) route = found
        }

        dispatch({ type: 'SET_ROUTE', route })
        if (routesApiData.oneWay) {
          dispatch({ type: 'SET_ONEWAY', isOneWay: true })
        }
        dispatch({ type: 'SET_ROUTES_API_DATA', payload: routesApiData })
      } finally {
        dispatch({ type: 'SET_ROUTES_API_LOADING', payload: false })
      }
    }

    fetchRoutes()
  }, [minibookId, dispatch])
}
